import {
  SEARCH_USER_ERROR,
  SEARCH_USER_START,
  SEARCH_USER_SUCCESS,
} from 'constants/action-types/user/searchUser';

import apiAction from 'helpers/apiAction';
import formatPhone from 'helpers/formatPhone';

export default phoneNumber => dispatch =>
  dispatch(
    apiAction({
      url: `/users/search?search=${formatPhone(phoneNumber)}`,
      method: 'GET',
      API_REQUEST_START: SEARCH_USER_START,
      API_REQUEST_SUCCESS: SEARCH_USER_SUCCESS,
      API_REQUEST_FAILURE: SEARCH_USER_ERROR,
      onEnd: () => false,
    }),
  );
